/**
 * Utility helpers for email body lazy-loading logic in EmailViewModal.
 *
 * Extracted for testability — the "should we lazy-fetch?" decision is
 * non-trivial because mapEmailToComponent sets body = preview as a
 * fallback, making body always truthy even when the real body hasn't
 * been fetched yet.
 */

/**
 * Determines whether the modal should fire a lazy-fetch for the full
 * email body (including HTML).
 *
 * @param emailId       - The email UUID (null when no email selected)
 * @param inlineBodyHtml - bodyHtml from the mapped email prop (camelCase)
 * @param lazyBodyHtml   - The current lazy-loaded HTML state
 *                          null  = "not yet fetched"
 *                          ''    = "fetched, but email has no HTML"
 *                          string = "fetched, HTML available"
 */
export function shouldLazyFetchBody(
  emailId: string | null | undefined,
  inlineBodyHtml: string | null | undefined,
  lazyBodyHtml: string | null,
): boolean {
  if (!emailId) return false;
  if (inlineBodyHtml) return false; // already have inline HTML
  if (lazyBodyHtml !== null) return false; // already fetched ('' or content)
  return true;
}
